import { useHandleAnalytics } from "../lib/analytics";
import {
  useHandleCardAnalytics,
  injectCardsContext
} from "../lib/card-analytics";
import { AnalyticEvents, AnalyticsBet } from "@fresh8/types/src/analytics";
import { usePixelMacros } from "../composition/pixelMacros";
import { BetSelection } from "@fresh8/types/src/betSelection";
import { InjectionKey, inject, provide } from "vue";

const CardNumberSymbol: InjectionKey<string> = Symbol("CardNumber");

/**
 * injects the current cards position index within a carosel (used for analytics)
 * @returns string (index starting from "1")
 */
// THIS WAS CREATED TO GET RID OF UNNESSESSCARY PROP DRILLING THROUGH EVERY COMPONENT
export function injectCardNumber(): string {
  return inject(CardNumberSymbol, "1");
}
export function provideCardNumber(cardNumber: string) {
  provide(CardNumberSymbol, cardNumber);
}

export const useAnalytics = (
  props: {
    marketId?: string;
    eventId?: string;
    optionId?: string;
    cardNumber?: string;
    optionName?: string;
  },
  statsDesc: string
): {
  handleClick: (betSelections?: BetSelection[]) => void;
  handleViewed: (bets: AnalyticsBet[], refireAfter?: number) => void;
  handleCardAnalyticsViewed: () => void;
} => {
  const {
    getPixelUrl,
    getPixelMacroData,
    populatePixelUrl,
    getPixelType
  } = usePixelMacros();
  const $handleAnalytics = useHandleAnalytics();
  const $handleCardAnalytics = useHandleCardAnalytics();

  const handleClick = (betSelections?: BetSelection[]) => {
    const statsEvent = AnalyticEvents.CLICKED_THROUGH;
    let pixelData;
    let bets;
    const hasDynamicBetSelections = !!betSelections?.length;

    // Map selection and pixel data for Parlay click throughs
    if (!!betSelections && hasDynamicBetSelections) {
      pixelData = getPixelMacroData(betSelections[0]);
      bets = betSelections.map(selection => ({
        betOptionID: selection.optionId,
        betID: selection.marketId
      }));
    } else {
      pixelData = getPixelMacroData(props);
      bets =
        props.optionId && props.marketId
          ? [
              {
                betOptionID: props.optionId,
                betID: props.marketId
              }
            ]
          : [];
    }

    const pixelUrl = getPixelUrl(statsEvent);
    const pixelType = getPixelType();

    $handleCardAnalytics(
      statsEvent,
      statsDesc,
      undefined,
      props.cardNumber,
      props.optionName
    );
    return $handleAnalytics(
      statsEvent,
      statsDesc,
      bets,
      // Only apply pixel data if pixelUrl exists.
      pixelUrl
        ? pixelData
          ? populatePixelUrl(pixelData, pixelUrl)
          : pixelUrl
        : undefined,
      pixelType
    );
  };

  const handleViewed = (bets: AnalyticsBet[], refireAfter?: number) => {
    const statsEvent = AnalyticEvents.VIEWED;
    const pixelType = getPixelType();
    const pixelUrl = getPixelUrl(statsEvent);

    $handleAnalytics(
      statsEvent,
      statsDesc,
      bets,
      pixelUrl,
      pixelType,
      refireAfter
    );
  };

  const handleCardAnalyticsViewed = () => {
    const statsEvent = AnalyticEvents.IMPRESSION;
    const cards = injectCardsContext();
    $handleCardAnalytics(
      statsEvent,
      statsDesc,
      cards.value.cards,
      props.cardNumber
    );
  };

  return { handleClick, handleViewed, handleCardAnalyticsViewed };
};

//TODO: make Pixels work with multiple selections
